module.exports = __webpack_public_path__ + "static/media/REW_Email.5d397636.jpg";